function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.9 17.8a1.042 1.042 0 0 0 .6-1.3v-.1a7.021 7.021 0 0 1-.5-2.7 5.92 5.92 0 0 1 .8-2.6c.2-.5.4-1 .7-1.6a7.2 7.2 0 0 0 .5-2.1 7.154 7.154 0 0 0-.3-2.1c-.1-.3-.3-.7-.4-1a6.583 6.583 0 0 1-.8-.895.908.908 0 0 0-1-.3 1.1 1.1 0 0 0-.8 1.2l.1.4a2.164 2.164 0 0 0 .2.6c0 .2.1.4.1.6a4.739 4.739 0 0 1 0 1.2 8.735 8.735 0 0 1-.4 1.2L61 9.9a9.742 9.742 0 0 0-.6 1.8 14.657 14.657 0 0 0-.2 2.1 6.6 6.6 0 0 0 1.6 3.7 1.067 1.067 0 0 0 1.1.3z",
  transform: "translate(-60.199 -2.455)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9 17.2a1.042 1.042 0 0 0 .6-1.3v-.1a7.021 7.021 0 0 1-.5-2.7 5.92 5.92 0 0 1 .8-2.6c.2-.5.4-1 .7-1.6a7.2 7.2 0 0 0 .5-2.1 7.154 7.154 0 0 0-.3-2.1c-.1-.3-.3-.7-.4-1a5.241 5.241 0 0 0-.7-.9.908.908 0 0 0-1-.3 1.1 1.1 0 0 0-.8 1.2l.1.4a2.164 2.164 0 0 0 .2.6c0 .2.1.4.1.6a4.739 4.739 0 0 1 0 1.2c-.2.5-.3.8-.5 1.2L68 9.3a9.742 9.742 0 0 0-.6 1.8 14.656 14.656 0 0 0-.2 2.1 6.6 6.6 0 0 0 1.6 3.7 1.128 1.128 0 0 0 1.1.3z",
  transform: "translate(-60.199 -2.455)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M77 17.8a1.042 1.042 0 0 0 .6-1.3v-.1a7.021 7.021 0 0 1-.5-2.7 5.92 5.92 0 0 1 .8-2.6c.2-.5.4-1 .7-1.6a7.2 7.2 0 0 0 .5-2.1 7.154 7.154 0 0 0-.3-2.1c-.1-.3-.3-.7-.4-1a3.635 3.635 0 0 1-.9-.895.908.908 0 0 0-1-.3 1.1 1.1 0 0 0-.8 1.2l.1.4a2.164 2.164 0 0 0 .2.6c0 .2.1.4.1.6a4.739 4.739 0 0 1 0 1.2 8.736 8.736 0 0 1-.4 1.2L75 9.9a9.742 9.742 0 0 0-.6 1.8 14.656 14.656 0 0 0-.2 2.1 6.6 6.6 0 0 0 1.6 3.7 1.25 1.25 0 0 0 1.2.3z",
  transform: "translate(-60.199 -2.455)"
});

function SvgSteam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.903,
    height: 15.382,
    viewBox: "0 0 18.903 15.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.eecf74ce.svg";
export { ForwardRef as ReactComponent };